import * as angular from "angular";
import {IPromise, IQService} from "angular";
import {workLoadModel} from "../models/work-load.model";
import {SplitService} from "../../commons/services/split-service.service";
import {ApiConfig} from "../../commons/models/api-config.model";

export class WorkloadRequests {

  constructor(private WorkloadApi, private $workload, private Upload,
              private splitService: SplitService,
              private $q: IQService,
              private apiConfig: ApiConfig) {
  }

  getTotals(holderId: string, holderType: string, from, to) {
    const api = this.WorkloadApi.actions.getTotals;
    return this.$$call(api, {
      holderId: holderId,
      holderType: holderType,
      from: from,
      to: to,
    }, {}, {});
  }

  getWorkLoad(holderId: string, holderType: string) {
    const api = this.WorkloadApi.actions.getWorkload;
    return this.$$call(api, {
      holderId: holderId,
      holderType: holderType,
    }, {}, {});
  }

  updateWorkLoad(workLoadId: any, payload: workLoadModel): IPromise<any> {
    const api = this.WorkloadApi.actions.updateWorkload;
    return this.$$call(api, {}, payload, {workLoadId: workLoadId});
  }

  validateImport(file, intervalMinutes, holderId: string, holderType: string) {
    const deferred = this.$q.defer();
    const siteId = this.splitService.getSiteId();

    this.Upload.upload({
      url: this.apiConfig.baseUrl + `/workload/totals/validate-import`,
      method: 'POST',
      params: {
        siteId: siteId,
        intervalMinutes: intervalMinutes,
        holderId: holderId,
        holderType: holderType
      },
      data: {
        file: file
      }
    })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch((response) => {
        deferred.reject(response.data);
      });

    return deferred.promise;
  }

  import(workloadData) {
    const api = this.WorkloadApi.actions.upload;
    return this.$$call(api, {}, workloadData, {});
  }

  getAttendanceState(holderId: string, holderType: string) {
    const api = this.WorkloadApi.actions.getAttendanceState;
    return this.$$call(api, {holderId: holderId, holderType: holderType}, {}, {});
  }

  getAttendanceFuture(holderId: string, holderType: string) {
    const api = this.WorkloadApi.actions.getAttendanceFuture;
    return this.$$call(api, {holderId: holderId, holderType: holderType}, {}, {});
  }

  private $$call(_apiCall, _params, _data, _options) {
    return this.$workload().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.workload')
  .service('workloadRequests', WorkloadRequests);

